import { OnInit } from '@angular/core';
var LabelComponent = /** @class */ (function () {
    function LabelComponent() {
    }
    LabelComponent.prototype.ngOnInit = function () {
    };
    return LabelComponent;
}());
export { LabelComponent };
